import { Injectable, signal } from '@angular/core';
import { VatRatesFe, VatRatesFields, VatRatesForm, VatRatesFormGroups, VatRatesValidators } from '../vat-rates-model';
import { CustomFormControl, CustomFormGroup } from '@tilby/tilby-ui-lib/components/tilby-magic-form';
import { Validators } from '@angular/forms';
import { Vat } from 'tilby-models';

@Injectable()
export class VatRateDetailsFormService {

  private vatRateForm!: VatRatesFormGroups;
  vatRateFormReady = signal(false);

  get form() {
    return this.vatRateForm;
  }

  validators: VatRatesValidators = {
    valueMinValue: 0,

    // --------
    provMinLength: 0,
    provMaxLength: 255,
    provMaxLengthArray: new Array(10).fill(2)
  };

  createForm(vatRate: VatRatesFields = new VatRatesFe() ,hiddenFields?:Array<keyof VatRatesFields>) {
    this.vatRateForm = new CustomFormGroup<VatRatesForm>({
      id: new CustomFormControl(
        vatRate.id >=0 ? vatRate.id : null
      ),
      value: new CustomFormControl(
        vatRate.value != null ? vatRate.value : null,
        { validators: [Validators.required, Validators.min(this.validators.valueMinValue)] }
      ),
      code: new CustomFormControl(
        vatRate.code || null
      )
    });

    this.vatRateFormReady.set(true);
    return this.vatRateForm;
  }
  
  resetFormValues(vatRate: Vat = new VatRatesFe()) {
    this.vatRateForm.patchValue({
      id: vatRate.id >= 0 ? vatRate.id : null,
      value: vatRate.value != null ? vatRate.value : null,
      code: vatRate.code || null
    });

    this.vatRateForm.markAsPristine();
  }

  getVatRateFields(currentVatRate: Vat = new VatRatesFe()): Partial<Vat> {
    // Clono l'oggetto di destinazione per non mutare l'originale
    const updatedVatRate = { ...currentVatRate }; 

    // Recupero tutte le chiavi (nomi dei campi) presenti nel form
    const vatRateFieldsToMap = Object.keys(this.vatRateForm.controls);

    // Ciclo su tutte le chiavi trovate nel form
    vatRateFieldsToMap.forEach((key: string) => {
      const control = this.vatRateForm.get(key);

      if(control) {
        let value = control.value;

        if(key === 'code') value = value || null;

        // Assegno il valore all'oggetto
        (updatedVatRate as any)[key] = value
      }
    })
    return updatedVatRate;
  }

  get id() {
    return this.vatRateForm.controls.id;
  }

  get value() {
    return this.vatRateForm.controls.value;
  }

  get code() {
    return this.vatRateForm.controls.code;
  }
}
